export default __webpack_public_path__ + "static/banner-padrao-2-ee00e681dc42c31d9abf5642c6ccd7fb.png";